import { useMutation } from "@tanstack/react-query";

import { ContactFormFields } from "@/api/contact-us/types";
import { SuccessResponse, TServerError } from "@/types/api/shared";

import { postHelpRequest } from "../api/contact-us/index";

export const useContactUs = () => {
  return useMutation<SuccessResponse, TServerError, ContactFormFields>({
    mutationFn: (body: ContactFormFields) => postHelpRequest(body),
  });
};
